<div class="chat">
    <iframe [src]="frameUrl"
            frameborder="0"></iframe>
</div>
